/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SubscribeMarketingConsentDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * UserMarketingApi - axios parameter creator
 * @export
 */
export const UserMarketingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Subscribes a user to marketing by giving consent
         * @param {string} userId 
         * @param {SubscribeMarketingConsentDTO} subscribeMarketingConsentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveMarketingConsent: async (userId: string, subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('giveMarketingConsent', 'userId', userId)
            // verify required parameter 'subscribeMarketingConsentDTO' is not null or undefined
            assertParamExists('giveMarketingConsent', 'subscribeMarketingConsentDTO', subscribeMarketingConsentDTO)
            const localVarPath = `/users/{userId}/marketing/giveMarketingConsent`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeMarketingConsentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMarketingApi - functional programming interface
 * @export
 */
export const UserMarketingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserMarketingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Subscribes a user to marketing by giving consent
         * @param {string} userId 
         * @param {SubscribeMarketingConsentDTO} subscribeMarketingConsentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giveMarketingConsent(userId: string, subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giveMarketingConsent(userId, subscribeMarketingConsentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserMarketingApi - factory interface
 * @export
 */
export const UserMarketingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserMarketingApiFp(configuration)
    return {
        /**
         * 
         * @summary Subscribes a user to marketing by giving consent
         * @param {string} userId 
         * @param {SubscribeMarketingConsentDTO} subscribeMarketingConsentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveMarketingConsent(userId: string, subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO, options?: any): AxiosPromise<void> {
            return localVarFp.giveMarketingConsent(userId, subscribeMarketingConsentDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for giveMarketingConsent operation in UserMarketingApi.
 * @export
 * @interface UserMarketingApiGiveMarketingConsentRequest
 */
export interface UserMarketingApiGiveMarketingConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMarketingApiGiveMarketingConsent
     */
    readonly userId: string

    /**
     * 
     * @type {SubscribeMarketingConsentDTO}
     * @memberof UserMarketingApiGiveMarketingConsent
     */
    readonly subscribeMarketingConsentDTO: SubscribeMarketingConsentDTO
}

/**
 * UserMarketingApi - object-oriented interface
 * @export
 * @class UserMarketingApi
 * @extends {BaseAPI}
 */
export class UserMarketingApi extends BaseAPI {
    /**
     * 
     * @summary Subscribes a user to marketing by giving consent
     * @param {UserMarketingApiGiveMarketingConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMarketingApi
     */
    public giveMarketingConsent(requestParameters: UserMarketingApiGiveMarketingConsentRequest, options?: AxiosRequestConfig) {
        return UserMarketingApiFp(this.configuration).giveMarketingConsent(requestParameters.userId, requestParameters.subscribeMarketingConsentDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
